import React, { useEffect, useState } from 'react';
import {
    Breadcrumb, Layout, Row, Col, Form, Button, Select,
    Table, Card, Tag, DatePicker, Space,
    Spin, Popconfirm, Tooltip
} from 'antd';
import { AlertError, AlertSuccess } from '../usableclasses.js';

import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { Link, useNavigate } from "react-router-dom";
import { MAINAPIURL, APPBACKGROUND_COLOR } from '../appsettings.js';
import axios from 'axios';

const { Content } = Layout;
const { Option } = Select;
const { RangePicker } = DatePicker;

function StocksTransfer() {
    const navigator = useNavigate()
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");

    const [filterForm] = Form.useForm();

    const [transfers, setTransfers] = useState([])
    const [filters, setFilters] = useState({});
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    const [stocks, setStocks] = useState([]);
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        fetchTransfers();
        fetchDropdown();
    }, []);

    const fetchDropdown = async () => {
        try {
            setIsLoading(true)
            const headers = { SystemAccessToken: TOKEN };
            const res = await axios.get(`${ApiURL}/stocks/all`, { headers });
            setStocks(res.data);
        } catch (error) {
            AlertError("Failed to Load Stocks");
        } finally {
            setIsLoading(false)
        }
    };

    const fetchTransfers = async (filterValues = {}, paginationValues = pagination) => {
        try {
            setIsLoading(true);
            const headers = { SystemAccessToken: TOKEN };

            const payload = {
                fromStock: filterValues.filterFrom || "",
                toStock: filterValues.filterTo || "",
                startDate: filterValues.dateRange?.[0]?.format('YYYY-MM-DD') || "",
                endDate: filterValues.dateRange?.[1]?.format('YYYY-MM-DD') || "",
                currentStatus: filterValues.status || "",
                pageLength: paginationValues.pageSize,
                pageNumber: paginationValues.current
            };

            const res = await axios.post(`${ApiURL}/stocktransfer/transferlistfilter`, payload, { headers });

            setTransfers(res.data.dataList);
            setPagination({
                ...paginationValues,
                total: res.data.rowcount
            });
        } catch (error) {
            AlertError("Fails to load transfers.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleFilter = (values) => {
        setFilters(values);
        fetchTransfers(values, { ...pagination, current: 1 });
    };

    const handleTableChange = (paginationInfo) => {
        const newPagination = {
            ...pagination,
            current: paginationInfo.current,
            pageSize: paginationInfo.pageSize
        };
        setPagination(newPagination);
        fetchTransfers(filters, newPagination);
    };

    const handleCreateTransfer = async (values) => {
        if (values.fromStockId === values.toStockId) {
            AlertError("Cannot transfer to the same stock.");
            return;
        }

        const headers = { SystemAccessToken: TOKEN };
        const payload = {
            fromStockId: Number(values.fromStockId),
            toStockId: Number(values.toStockId),
            createdBy: UPDATED_BY
        };

        try {
            setIsLoading(true)
            const res = await axios.post(`${ApiURL}/stocktransfer/create`, payload, { headers });
            const id = res.data;
            navigator(`/stocks/transfer/${id}`);
        } catch (error) {
            AlertError("Failed to create stock transfer.");
        } finally {
            setIsLoading(false)
        }
    };

    const handleEditTransfer = async (id) => {
        try {
            setIsLoading(true)
            navigator(`/stocks/transfer/${id}`);
        } catch (error) {
            AlertError("Failed to edit stock transfer.");
        } finally {
            setIsLoading(false)
        }
    };

    const deletTansfer = async (id) => {
        try {
            setIsLoading(true)
            const headers = { SystemAccessToken: TOKEN };
            const payload = {
                transferId: Number.parseInt(id),
                status: "CANCEL",
                updatedBy: UPDATED_BY
            };

            await axios.post(`${ApiURL}/stocktransfer/completetransfer`, payload, { headers });
            AlertSuccess("Transfer delete completed.");
            fetchTransfers();
        } catch (error) {
            AlertError("Failed to delete stock transfer.");
        } finally {
            setIsLoading(false)
        }

    }


    const getStatusBadge = (status) => {
        switch ((status || '').toUpperCase()) {
            case 'DRAFT':
                return <Tag color="blue">Draft</Tag>;
            case 'COMPLETED':
                return <Tag color="green">Completed</Tag>;
            case 'CANCELED':
                return <Tag color="red">Canceled</Tag>;
            default:
                return <Tag color="default">{status}</Tag>;
        }
    };

    const transferColumn = [
        { title: "Reference ID", dataIndex: "transferReferance" },
        {
            title: 'Date', dataIndex: 'createDate', render: (_, record) => (
                <Space>
                    {new Date(record.createDate).toLocaleDateString()}
                </Space>
            )
        },
        { title: "Year", dataIndex: "sysYear" },
        { title: "Month", dataIndex: "sysMonth" },
        { title: 'From Stock', dataIndex: 'fromStock' },
        { title: 'To Stock', dataIndex: 'toStock' },
        { title: 'Total Products', dataIndex: 'totalProducts' },
        { title: 'Total Qty', dataIndex: 'totalQty' },
        {
            title: 'Status',
            dataIndex: 'currentStatus',
            render: (_, record) => (
                <Space>
                    {getStatusBadge(record.currentStatus)}
                </Space>
            )
        },
        {
            title: "Actions",
            value: "transferId",
            key: "actions",
            fixed: "left",
            render: (_, record) => (
                <Space>
                    {record.currentStatus === "DRAFT" && (
                        <Row gutter={8}>
                            <Col>
                                <Button
                                    type="default"
                                    onClick={() => handleEditTransfer(record.transferId)}
                                    disabled={isLoading}
                                    size='small'
                                    style={{

                                        borderColor: '#fadb14', // Yellow border
                                        color: '#fadb14',
                                    }}
                                >
                                    Edit
                                </Button>
                            </Col>
                            <Col>
                                <Popconfirm
                                    title="Are you sure to delete this transfer?"
                                    onConfirm={() => deletTansfer(record.transferId)}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Tooltip title="Delete">
                                        <Button
                                            type="default"
                                            style={{
                                                borderColor: '#ff4d4f', // Red border
                                                color: '#ff4d4f',
                                            }}
                                            size="small"
                                            disabled={isLoading}
                                        >
                                            Delete
                                        </Button>
                                    </Tooltip>
                                </Popconfirm>
                            </Col>
                        </Row>
                    )}

                    {(record.currentStatus === "COMPLETED" || record.currentStatus === "CANCELED") && (
                        <Row gutter={8}>
                            <Col>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        navigator(`/stocks/transfer/print/${record.transferId}`)
                                    }}
                                    size="small"
                                    disabled={isLoading}
                                    style={{
                                        backgroundColor: '#722ed1', // Purple
                                        borderColor: '#722ed1',
                                    }}
                                >
                                    Print
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        navigator(`/stocks/transfer/view/${record.transferId}`)
                                    }}
                                    size="small"
                                    disabled={isLoading}
                                >
                                    View
                                </Button>
                            </Col>
                        </Row>
                    )}
                </Space>

            ),
        }
    ];

    return (
        <Spin spinning={isLoading} tip="Processing...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
                <Headerdiv />
                <Content style={{ padding: '20px' }}>
                    <Breadcrumb style={{ margin: '16px 0' }}>
                        <Breadcrumb.Item><Link to={"/stocks/management"}>Stocks</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>Stocks Transfer</Breadcrumb.Item>
                    </Breadcrumb>

                    {/* Create New Transfer */}
                    <Card title="Create New Transfer" style={{ marginBottom: 20 }}>
                        <Form layout="inline" onFinish={handleCreateTransfer}>
                            <Form.Item label="From Stock" name="fromStockId"
                                rules={[{ required: true, message: 'Please select the stock to transfer **from**' }]}
                            >
                                <Select placeholder="Select From Stock" style={{ width: 200 }}>
                                    {stocks.map(stock => (
                                        <Option key={stock.stockId} value={stock.stockId}>{stock.stockName}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item label="To Stock" name="toStockId"
                                rules={[{ required: true, message: 'Please select the stock to transfer **to**' }]}
                            >
                                <Select placeholder="Select To Stock" style={{ width: 200 }}>
                                    {stocks.map(stock => (
                                        <Option key={stock.stockId} value={stock.stockId}>{stock.stockName}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" htmlType="submit">Create Transfer</Button>
                            </Form.Item>
                        </Form>
                    </Card>

                    <Card title="Transfer List" style={{ marginBottom: 20 }}>
                        <Form useForm={filterForm} onFinish={handleFilter}>
                            <Row gutter={16} align="bottom">
                                <Col xs={24} sm={12} md={5}>
                                    <Form.Item label="From Stock" name="filterFrom">
                                        <Select allowClear placeholder="From Stock">
                                            {stocks.map(stock => (
                                                <Option key={stock.stockId} value={stock.stockId}>{stock.stockName}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={5}>
                                    <Form.Item label="To Stock" name="filterTo">
                                        <Select allowClear placeholder="To Stock">
                                            {stocks.map(stock => (
                                                <Option key={stock.stockId} value={stock.stockId}>{stock.stockName}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item label="Date Range" name="dateRange">
                                        <RangePicker style={{ width: '100%' }} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={4}>
                                    <Form.Item label="Status" name="status">
                                        <Select allowClear placeholder="Status">
                                            <Option value="COMPLETED">COMPLETED</Option>
                                            <Option value="DRAFT">DRAFT</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={24} md={4}>
                                    <Form.Item>
                                        <Space>
                                            <Button type="primary" htmlType="submit">Filter</Button>
                                            <Button htmlType='reset' onClick={() => filterForm.resetFields()}>Clear</Button>
                                        </Space>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Card>

                    <Card title="Transfer List">
                        <Table
                            columns={transferColumn}
                            dataSource={transfers}
                            rowKey={(record, i) => i}
                            pagination={{
                                current: pagination.current,
                                pageSize: pagination.pageSize,
                                total: pagination.total,
                            }}
                            loading={isLoading}
                            onChange={handleTableChange}
                        />

                    </Card>
                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
}

export default StocksTransfer;
